import { produce } from 'immer';
import { RemoteRecordData } from 'b2b-apps/shop/common/redux/RemoteRecordData';
import {
  ADD_EXPRESS_ORDER_ITEMS_TO_CART,
  ADD_EXPRESS_ORDER_ITEMS_TO_CART_FULFILLED,
  ADD_EXPRESS_ORDER_ITEMS_TO_CART_REJECTED,
  ADD_EXPRESS_ORDER_ITEMS_TO_WISHLIST,
  ADD_EXPRESS_ORDER_ITEMS_TO_WISHLIST_FULFILLED,
  ADD_EXPRESS_ORDER_ITEMS_TO_WISHLIST_REJECTED,
  CLEAR_ADD_EXPRESS_ORDER_ITEMS_TO_CART,
  CLEAR_ADD_EXPRESS_ORDER_ITEMS_TO_WISHLIST,
  CLEAR_EXPRESS_ORDER,
  REMOVE_VERIFY_ITEM,
  UPLOAD_CSV,
  UPLOAD_CSV_FULFILLED,
  UPLOAD_CSV_REJECTED,
  VERIFY,
  VERIFY_FULFILLED,
  VERIFY_REJECTED,
} from 'b2b-apps/shop/expressOrder/redux/actionTypes';
import {
  ExpressOrderActions,
  ExpressOrderState,
} from 'b2b-apps/shop/expressOrder/redux/types';

const initialState: ExpressOrderState = {
  addItemsToCart: RemoteRecordData.getDefault(),
  addItemsToWishlist: RemoteRecordData.getDefault(),
  verify: RemoteRecordData.getDefault(),
};

const reducer = (
  state: ExpressOrderState = initialState,
  action: ExpressOrderActions,
): ExpressOrderState => {
  switch (action.type) {
    case ADD_EXPRESS_ORDER_ITEMS_TO_CART:
      return produce(state, (draft: ExpressOrderState) => {
        draft.addItemsToCart = RemoteRecordData.init();
      });

    case ADD_EXPRESS_ORDER_ITEMS_TO_CART_FULFILLED:
      return produce(state, (draft: ExpressOrderState) => {
        draft.addItemsToCart = RemoteRecordData.fulfill(action.payload.data);
      });

    case ADD_EXPRESS_ORDER_ITEMS_TO_CART_REJECTED:
      return produce(state, (draft: ExpressOrderState) => {
        draft.addItemsToCart = RemoteRecordData.reject(action.payload.error);
      });

    case ADD_EXPRESS_ORDER_ITEMS_TO_WISHLIST:
      return produce(state, (draft: ExpressOrderState) => {
        draft.addItemsToWishlist = RemoteRecordData.init();
      });

    case ADD_EXPRESS_ORDER_ITEMS_TO_WISHLIST_FULFILLED:
      return produce(state, (draft: ExpressOrderState) => {
        draft.addItemsToWishlist = RemoteRecordData.fulfill(
          action.payload.data,
        );
      });

    case ADD_EXPRESS_ORDER_ITEMS_TO_WISHLIST_REJECTED:
      return produce(state, (draft: ExpressOrderState) => {
        draft.addItemsToWishlist = RemoteRecordData.reject(
          action.payload.error,
        );
      });

    case CLEAR_ADD_EXPRESS_ORDER_ITEMS_TO_CART:
      return produce(state, (draft: ExpressOrderState) => {
        draft.addItemsToCart = initialState.addItemsToCart;
      });

    case CLEAR_ADD_EXPRESS_ORDER_ITEMS_TO_WISHLIST:
      return produce(state, (draft: ExpressOrderState) => {
        draft.addItemsToWishlist = initialState.addItemsToWishlist;
      });

    case CLEAR_EXPRESS_ORDER:
      return initialState;

    case REMOVE_VERIFY_ITEM:
      return produce(state, (draft: ExpressOrderState) => {
        const data = state.verify && Array.isArray(state.verify.data)
          ? state.verify.data.filter(
            (item, index) => index !== action.payload.index,
          )
          : [];
        draft.verify = RemoteRecordData.fulfill(data);
      });

    case UPLOAD_CSV:
    case VERIFY:
      return produce(state, (draft: ExpressOrderState) => {
        draft.verify = Object.assign(RemoteRecordData.init(), {
          data: draft.verify.data,
        });
      });

    case UPLOAD_CSV_FULFILLED:
    case VERIFY_FULFILLED:
      return produce(state, (draft: ExpressOrderState) => {
        draft.verify = RemoteRecordData.fulfill(action.payload.data);
      });

    case UPLOAD_CSV_REJECTED:
    case VERIFY_REJECTED:
      return produce(state, (draft: ExpressOrderState) => {
        draft.verify = RemoteRecordData.reject(action.payload.error);
      });

    default:
      return state;
  }
};

export { reducer };
